import { styled } from 'styled-components';

const DoiModalTitle = styled.p`
  font-weight: 700;
  margin-bottom: 12px;
`;

export const doiModalChildren = (nlTitle: string) => (
  <>
    <DoiModalTitle>Please confirm your e-mail address to finish signing up.</DoiModalTitle>
    <p>Click the confirmation link we’ve sent to your inbox to begin receiving the {nlTitle}</p>
  </>
);

export default doiModalChildren;
